import React, {useState, useEffect} from "react" ;

import LetterboxAppSidebar from "./Sidebar/LetterboxAppSidebar";
import LetterboxAppBody from "./Body/LetterboxAppBody";
import LetterboxProvider from "root/contexts/LetterboxProvider";

const WieldyApplicationModuleLetterbox = (props) =>
{
    const [height, setHeight] = useState(props.height);
    const [width, setWidth] = useState(props.width);

    const pageStyle = {height: '' + (+height - 1) + 'px'};

    useEffect(() => {
        setHeight(props.height);
        setWidth(props.width);
    }, [props.height, props.width]);

    return (
        <div className="row">
            <div className="col-xl-12">

                { /* Module */}
                <div className="dt-module" style={pageStyle}>

                    <LetterboxProvider>
                        <LetterboxAppSidebar title={'Letterbox'} iconName={'icon-email'} height={height}/>
                        <LetterboxAppBody height={height} width={width}/>
                    </LetterboxProvider>
                    { /* <LetterboxAppDrawer /> */}

                </div>
            </div>
        </div>
    );
}

export default WieldyApplicationModuleLetterbox;